import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.js';
import clsx from 'clsx';
import { getRandomInt } from '@/utils/get-random-int';
import {
  postCardActions,
  postCardBody,
  postCardContainer,
  postCardContent,
  postCardDate,
  postCardFooter,
  postCardLabels,
} from '../post-card/post-card.css';
import {
  streamPostCardActions,
  streamPostCardContainer,
  streamPostCardFooter,
  streamPostCardLabels,
} from './stream-post-card.css';

export const StreamPostCardSkeleton = () => {
  return (
    <div className={clsx(postCardContainer, streamPostCardContainer)}>
      <div className={postCardContent}>
        <div className={postCardBody}>
          <Skeleton height={42} width={getRandomInt(70, 100) + '%'} />
        </div>
        <div className={postCardDate}>
          <Skeleton height={14} width={140} />
        </div>
      </div>

      <div className={clsx(streamPostCardFooter, postCardFooter)}>
        <div className={clsx(streamPostCardActions, postCardActions)}>
          <Skeleton height={34} width={80} radius={32} />
          <Skeleton height={34} width={80} radius={32} />
        </div>
        <div className={clsx(postCardLabels, streamPostCardLabels)}>
          <Skeleton width={90} height={30.2} radius={32} />
        </div>
      </div>
    </div>
  );
};
